import {
  type ReferentialAxisEntity,
  ReferentialAxisSchema
} from '@/core/infrastructure/schemas/referential/axis/ReferentialAxisSchema.ts'
import { ReferentialDomain } from '@/core/domain/referential/domain/ReferentialDomain.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

export class ReferentialAxis {
  id: number
  title: string
  order: number
  domains: ReferentialDomain[]

  constructor(axis: ReferentialAxisEntity) {
    this.id = axis.id
    this.title = axis.title
    this.order = axis.order || 0 // Valeur par défaut si non défini
    this.domains = []

    // Utiliser EntityValidator pour traiter les domaines
    if (axis.domains && Array.isArray(axis.domains)) {
      try {
        this.domains = axis.domains.map((domain) => ReferentialDomain.create(domain))
      } catch (error) {
        console.warn('Erreur lors de la validation des domaines:', error)
        // Ne pas faire échouer la création de l'axe si les domaines sont invalides
        this.domains = []
      }
    }
  }

  /**
   * Obtient les domaines triés par ordre
   */
  public getSortedDomains(): ReferentialDomain[] {
    return [...this.domains].sort((a, b) => a.order - b.order)
  }

  /**
   * Trouve un domaine par son ID
   */
  public findDomainById(domainId: number): ReferentialDomain | undefined {
    return this.domains.find((domain) => domain.id === domainId)
  }

  /**
   * Vérifie si l'axe contient un domaine spécifique
   */
  public hasDomain(domainId: number): boolean {
    return this.domains.some((domain) => domain.id === domainId)
  }

  /**
   * Méthode de création statique qui valide les données avant instanciation
   */
  public static create(data: unknown): ReferentialAxis {
    return EntityValidator.validateAndCreate(
      ReferentialAxisSchema,
      data,
      ReferentialAxis,
      'ReferentialAxis'
    )
  }
}
